import { FormGroup } from "../db/definitions";
import { updateFormGroup } from "../db/queries/formGroupQueries";
import updateFormGroupAmplify from "./updateFormGroup";

export async function _updateFormGroup(formGroup: FormGroup, online: boolean): Promise<void> {
	if (online) {
		await updateFormGroupAmplify(formGroup);
	} else {
		await updateFormGroup(formGroup);
	}
}
